export default "__VITE_ASSET__BmLp7Kh___"